export default __webpack_public_path__ + "static/media/BioinfoFigure3.65674f90.svg";